import request from '../static/js/request'

export function getAliVideoUrl(data) {
  return request
    .get(`/cms/weixin/aliyun/video/findALiYunVideoByIds`, {
      params: data
    })
    .then((res) => res.data)
}
// /cms/weixin/aliyun/video/get-playinfo
export function getAliVideoInfo(data) {
  return request
    .get(`/cms/weixin/aliyun/video/get-playinfo`, {
      params: data
    })
    .then((res) => res.data)
}
